import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
// material
import { Card, Stack, Container, Typography, Box, Tab } from '@mui/material';
import { TabContext, TabPanel, TabList } from '@mui/lab';
// components
import { FadeLoader } from 'react-spinners';
import tracker from '../../../api/tracker';
import Page from '../../../components/Page';
import EventForm from './EventForm';
import EventPhotos from './EventPhotos';

// ----------------------------------------------------------------------

const override = { margin: '0 auto' };

export default function EditEvent() {
  const [loading, setLoading] = useState(true);
  const { hashid } = useParams();
  const [event, setEvent] = useState(null);
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState('1');

  const fetchEventData = async () => {
    try {
      const response = await tracker.get(`events/${hashid}`);
      setEvent(response.data.data);
    } catch (error) {
      console.error('Error fetching event:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, value) => {
    setTabIndex(value);
  };

  useEffect(() => {
    fetchEventData();
  }, [hashid]);

  return (
    <Page title={t('Event_form')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('Event_form')}
          </Typography>
        </Stack>

        <Card style={{ padding: '20px' }}>
          <TabContext value={tabIndex}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="event tabs">
                <Tab label={t('event_info')} value="1" />
                <Tab label={t('photos_videos')} value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              {loading && <FadeLoader color="blue" cssOverride={override} loading={loading} />}
              {!loading && event && <EventForm event={event} isEdit />}
              {!loading && !event && <Typography>{t('No event data')}</Typography>}
            </TabPanel>
            <TabPanel value="2">
              {loading && <FadeLoader color="blue" cssOverride={override} loading={loading} />}
              {!loading && event && <EventPhotos event={event} />}
              {!loading && !event && <Typography>{t('No event data')}</Typography>}
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}
